import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import queryDocument from "./getWishlists.graphql";
import type { WishlistsSearchParamsType } from "@/core/api/graphql/account";
import type { Query, QueryWishlistsArgs, WishlistConnection } from "@/core/api/graphql/types";

export async function getWishlists({
  itemsPerPage = 50,
  page = 1,
  sort,
  customerId,
}: Partial<WishlistsSearchParamsType>): Promise<WishlistConnection> {
  const { storeId, cultureName, userId, currencyCode } = globals;

  const { data } = await graphqlClient.query<Required<Pick<Query, "wishlists">>, QueryWishlistsArgs>({
    query: queryDocument,
    variables: {
      storeId,
      userId: customerId ? customerId : userId,
      cultureName,
      currencyCode,
      sort,
      first: itemsPerPage,
      after: String((page - 1) * itemsPerPage),
    },
  });

  return data.wishlists;
}
